import { render, staticRenderFns } from "./InvestorOnboardingAutomaticInvestment.vue?vue&type=template&id=23af0c36&scoped=true&"
import script from "./InvestorOnboardingAutomaticInvestment.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingAutomaticInvestment.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOnboardingAutomaticInvestment.vue?vue&type=style&index=0&id=23af0c36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af0c36",
  null
  
)

export default component.exports